import { useEffect, useState } from 'react';
import {
  useGetReportingsFootprintsDetails,
  useQueryData,
  GetFootprintsDetailsResponse,
  MonthYearInput,
  DEFAULT_OVERRIDE_CACHE_TIME,
} from '@ecolytiq/js-data-provider';

import { FootprintData } from 'impactApp/modules/HomePage';
import { useDeps } from 'App/context';
import { useNavigate } from 'react-router-dom';
import { RoutePaths } from 'impactApp/routes';

export const useFootprintListTransactionsData = (month: MonthYearInput) => {
  const { httpClientService } = useDeps();
  const [response, setResponse] = useState<Omit<FootprintData, 'isLoading'>>({
    list: [],
    monthlyCo2Footprint: 0,
  });
  const navigate = useNavigate();
  const { SSO_PAGE } = RoutePaths;
  const { list, monthlyCo2Footprint } = response;
  const { isLoading, isFetching, data } = useQueryData<{ data: GetFootprintsDetailsResponse }>(
    useGetReportingsFootprintsDetails(httpClientService, month),
    {
      staleTime: DEFAULT_OVERRIDE_CACHE_TIME,
      cacheTime: 0,
    }
  );

  useEffect(() => {
    if (data?.data.groupTransactionsByMetaCategory) {
      setResponse({
        list: data.data.groupTransactionsByMetaCategory.results,
        monthlyCo2Footprint: data.data.groupTransactionsByMetaCategory.info.totalCo2.value,
      });
    } else if (!isLoading && !data) {
      navigate(SSO_PAGE);
    }
  }, [data, setResponse, SSO_PAGE, navigate, isLoading]);

  return {
    isLoading: isLoading || isFetching,
    list,
    monthlyCo2Footprint,
  };
};
